
import {httpservice} from '../services';
import { USER } from "../constant/actionTypes";
import {constants} from "../constant/constant";


export default object => dispatch => {
    const query = `${constants.API.USER}`;
    dispatch({
        payload: {data: [], count: 0},
        type: USER.GET.INITIATE
    });
    return httpservice()
        .get(query)
        .then(response => {
            const count = response.data.response.count;
            const responseData = response.data.response.rows.map(data => ({
                id: data.id,
                firstName: data.firstName,
                lastName: data.lastName,
                name: data.firstName + ' ' + data.lastName,
                email: data.email,
                createdAt: data.createdAt,
                company: data.account && data.account.name ? data.account.name : '',
                accountId: data.account && data.account.id ? data.account.id : '',
                role: data.role ? data.role.roleName : '',
                roleId: data.role ? data.role.id : '',
                createdBy: data.creator ? data.creator.firstName + ' ' + data.creator.lastName : '',
                active: data.isBlocked ? 'Blocked' : (data.active ? 'Active' : 'Pending'),
                avatar: data.avatar || '',
                phoneNumber: data.phoneNumber || '',
                countryCode: data.countrycode || '',
            }));
            dispatch({
                payload: {data: responseData, count: count},
                type: USER.GET.SUCCESS
            });
        })
        .catch(function (error) {
            dispatch({
                payload: {data: [], count: 0, error: error},
                type: USER.GET.ERROR
            });
        });
};
